export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Prestige Event & Catering ',
    topLine2: 'Explore our beautiful homes',
    headline: 'Lokaler för alla tillfällen',
    headline2: 'Fantastisk matupplevelse',
    description: 'På Prestige Event & Catering erbjuder vi ett brett utbud av flexibla lokaler för alla typer av evenemang. Våra lokaler kan anpassas efter era önskemål och behov – oavsett om ni planerar en mindre och intim workshop, en inspirerande företagsaktivitet eller en storskalig konferens.',
    description2:'Maten är en viktig del av helhetsupplevelsen vid både event och konferenser. På Prestige Event & Catering väntar en kulinarisk upplevelse där kvalitet, kreativitet och smak står i fokus. Våra utvalda leverantörer erbjuder välkomponerade menyer med något för alla smaker.',
    imgStart: false,
    img: require('../../AssetsForHome/cake.jpg'),
    img2: require('../../AssetsForHome/food.jpg'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false,
}